import { withStyles } from "@material-ui/core/styles"
import styled from "styled-components"
import { mobileSize, tabletSize } from "../../constants"
import assetPrefix from "../../utils/assetPrefix"
import ButtonFilledOrange from "../buttons/button-filled-orange"
import Form from "../form"
import TextInput from "../inputs/text-input"

export const CompanyFields = styled(Form)`
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;

  -webkit-transition:
    flex-direction 0.3s ease-in,
    margin-bottom 0.3s ease-in;
  -moz-transition:
    flex-direction 0.3s ease-in,
    margin-bottom 0.3s ease-in;
  -o-transition:
    flex-direction 0.3s ease-in,
    margin-bottom 0.3s ease-in;
  transition:
    flex-direction 0.3s ease-in,
    margin-bottom 0.3s ease-in;

  @media (max-width: ${tabletSize}) {
    flex-direction: row;
    margin-bottom: 20px;
  }
  @media (max-width: ${mobileSize}) {
    flex-direction: column;
    margin-bottom: 0;
  }
`

export const EmailInput = styled(TextInput)`
  width: 100%;
  margin-right: 10px;
  transition:
    margin-right 0.3s ease-in,
    margin-bottom 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    margin-right: 10px;
  }
  @media (max-width: ${mobileSize}) {
    margin-right: 0;
    margin-bottom: 15px;
  }
`

export const NameInput = styled(TextInput)`
  width: 100%;
  margin-bottom: 0;
  @media (max-width: ${mobileSize}) {
    margin-bottom: 20px;
  }
`

export const BtnAndHints = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  transition:
    align-items 0.3s ease-in,
    flex-direction 0.3s ease-in;

  -webkit-transition:
    align-items 0.3s ease-in,
    flex-direction 0.3s ease-in;
  -moz-transition:
    align-items 0.3s ease-in,
    flex-direction 0.3s ease-in;
  -o-transition:
    align-items 0.3s ease-in,
    flex-direction 0.3s ease-in;
  transition:
    align-items 0.3s ease-in,
    flex-direction 0.3s ease-in;

  @media (max-width: ${tabletSize}) {
    align-items: center;
    flex-direction: row;
  }
  @media (max-width: ${mobileSize}) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const ContinueBtn = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontWeight: "bold",
    position: "relative",

    paddingLeft: 79,
    paddingRight: 78
  }
})(ButtonFilledOrange)

export const ArrowWhite = styled.img.attrs({
  src: `${assetPrefix}/images/ic-btn-arrow-next@3x.png`,
  alt: "White Arrow Icon",
  loading: "lazy"
})`
  height: 10px;
`

export const ArrowContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  right: 41px;
  top: 0;
  bottom: 0;
`

export const Hints = styled.span`
  margin-top: 0;
  font-size: 14px;
  font-weight: normal;

  -webkit-transition:
    margin-top 0.3s ease-in,
    font-size 0.3s ease-in;
  -moz-transition:
    margin-top 0.3s ease-in,
    font-size 0.3s ease-in;
  -o-transition:
    margin-top 0.3s ease-in,
    font-size 0.3s ease-in;
  transition:
    margin-top 0.3s ease-in,
    font-size 0.3s ease-in;

  @media (max-width: ${tabletSize}) {
    font-size: 14px;
    margin-top: 0;
  }
  @media (max-width: ${mobileSize}) {
    font-size: 12px;
    margin-top: 20px;
  }
`
